var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-wrap"},_vm._l((_vm.list),function(item){return _c('a',{key:item.name,staticClass:"d-block",attrs:{"href":item.url,"target":"_blank"}},[_vm._v(_vm._s('《' + item.name + '》'))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }